const breakpoints = {
  480: 'xs',
  768: 's',
  1024: 'm',
  1200: 'l',
  1401: 'xl',
}

export default breakpoints
